module.exports = __webpack_public_path__ + "static/img/icon_pro1.666fb20.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_pro1.png
// module id = i9Nc
// module chunks = 11